import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12d7dc4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade bg-white",
  id: "donationQueue",
  tabindex: "-1",
  "data-bs-keyboard": "false",
  "aria-hidden": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_3 = { class: "modal-content d-flex flex-row" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"d-none d-md-block position-relative bg-primary\" style=\"width:4.5rem;\" data-v-12d7dc4f><button type=\"button\" class=\"btn btn-primary back d-flex position-absolute end-0 rounded-circle border-white\" data-bs-dismiss=\"modal\" data-v-12d7dc4f><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"36\" height=\"36\" fill=\"#000000\" class=\"bi bi-chevron-left align-self-center\" viewBox=\"0 0 16 16\" data-v-12d7dc4f><path fill-rule=\"evenodd\" d=\"M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z\" data-v-12d7dc4f></path></svg></button><div class=\"mb-auto\" data-v-12d7dc4f></div></div>", 1)
const _hoisted_5 = { class: "container-fluid" }
const _hoisted_6 = { class: "pb-5 pt-0 px-3 px-md-5" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-start fw-bold pt-5 pb-4 border-0 border-3 border-bottom border-dark" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn d-flex d-md-none p-0 me-3",
    "data-bs-dismiss": "modal"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "56",
      height: "56",
      fill: "currentColor",
      class: "bi bi-arrow-left-short",
      viewBox: "0 0 16 16"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
      })
    ])
  ]),
  /*#__PURE__*/_createTextVNode("Donation Queue ")
], -1))
const _hoisted_8 = {
  class: "d-flex flex-column flex-sm-row justify-content-center justify-content-sm-end gap-3",
  style: {"margin-top":"2rem !important"}
}
const _hoisted_9 = { class: "dropdown" }
const _hoisted_10 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_13 = {
  class: "accordion",
  id: "queue",
  style: {"margin-top":"2rem !important"}
}
const _hoisted_14 = ["index"]
const _hoisted_15 = { class: "accordion-header" }
const _hoisted_16 = ["data-bs-target", "aria-controls"]
const _hoisted_17 = { class: "d-flex flex-row align-items-center text-black py-2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "avatar bg-secondary rounded-circle me-3" }, null, -1))
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-truncate fw-semibold m-0" }
const _hoisted_21 = { class: "fw-medium" }
const _hoisted_22 = ["id"]
const _hoisted_23 = { class: "accordion-body" }
const _hoisted_24 = { class: "row m-3 text-start" }
const _hoisted_25 = { class: "col-12 col-sm-6 mt-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Name", -1))
const _hoisted_27 = { class: "col-12 col-sm-6 mt-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Priority Number", -1))
const _hoisted_29 = { class: "col-12 col-sm-6 mt-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Queue Time", -1))
const _hoisted_31 = { class: "col-12 col-sm-6 mt-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Distance", -1))
const _hoisted_33 = { class: "col-12 mt-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "fw-semibold" }, "Donations Received", -1))
const _hoisted_35 = { class: "d-flex flex-column flex-md-row gap-2 justify-content-end mx-3 mb-4" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn dropdown-toggle text-black fs-6", { 'w-100 border border-black': _ctx.windowWidth <= 576 }]),
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, " Filter by: " + _toDisplayString(_ctx.filterBy), 3),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFilterBy('Name')))
                    }, " Name ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilterBy('Priority Number')))
                    }, " Priority Number ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFilterBy('Queue Time')))
                    }, " Queue Time ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFilterBy('Distance')))
                    }, " Distance ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setFilterBy('Donations Received')))
                    }, " Donations Received ")
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn dropdown-toggle text-black fs-6", { 'w-100 border border-black': _ctx.windowWidth <= 576 }]),
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, " Sort by: " + _toDisplayString(_ctx.sortBy), 3),
                _createElementVNode("ul", _hoisted_12, [
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setSortBy('Ascending')))
                    }, " Ascending ")
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "dropdown-item",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setSortBy('Descending')))
                    }, " Descending ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQueue, (queuer, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "accordion-item queuer rounded-0",
                  key: queuer.queuerId,
                  index: index
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      class: "accordion-button bg-transparent rounded-0 collapsed",
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": `#queuer-${index}`,
                      "aria-expanded": "false",
                      "aria-controls": `queuer-${index}`
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("h6", _hoisted_20, _toDisplayString(_ctx.truncateText(queuer.name)), 1),
                          _createElementVNode("small", null, [
                            _createElementVNode("strong", _hoisted_21, _toDisplayString(_ctx.getOrdinalSuffix(queuer.queuePos)), 1),
                            _createTextVNode(" • " + _toDisplayString(queuer.distance / 1000) + "km away", 1)
                          ])
                        ])
                      ])
                    ], 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", {
                    id: `queuer-${index}`,
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#queue"
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("p", null, _toDisplayString(queuer.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          _createElementVNode("p", null, _toDisplayString(_ctx.getOrdinalSuffix(queuer.queuePos)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("p", null, _toDisplayString(_ctx.getTime(queuer.createdAt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("p", null, _toDisplayString(queuer.distance / 1000) + "km away", 1)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("p", null, _toDisplayString(queuer.donationsReceived) + "/3 received today", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-secondary text-white rounded-0 flex-fill flex-md-grow-0 p-2",
                          "data-bs-dismiss": "modal",
                          onClick: ($event: any) => (_ctx.confirmQueuer(queuer))
                        }, " Confirm ", 8, _hoisted_36),
                        (index === 0)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "reset",
                              class: "btn btn-outline-dark rounded-0 flex-fill flex-md-grow-0 p-2",
                              "data-bs-dismiss": "modal",
                              onClick: ($event: any) => (_ctx.declineQueuer(queuer))
                            }, " Decline ", 8, _hoisted_37))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 8, _hoisted_22)
                ], 8, _hoisted_14))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}